import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReply, faShare } from '@fortawesome/free-solid-svg-icons';
import './styles.css';

const ItemFooterAction = props => {
  const { disabled, item, actions } = props;
  const { caption, cls, icon, handler } = actions;

  let iconClass;
  let iconEl;

  switch (icon) {
    case 'download':
      iconClass = 'item-footer-action__icon--download';
      break;
    case 'message':
      iconClass = 'item-footer-action__icon--message';
      break;
    case 'rate':
      iconClass = 'item-footer-action__icon--rate';
      break;
    case 'tag':
      iconClass = 'item-footer-action__icon--tag';
      break;
    case 'status':
      iconClass = 'item-footer-action__icon--status';
      break;
    case 'forward':
      iconClass = 'item-footer-action__icon--forward';
      break;
    case 'delete':
      iconClass = 'item-footer-action__icon--delete';
      break;
    case 'share':
      iconClass = 'item-footer-action__icon--share';
      break;
    case 'accept':
      iconClass = 'item-footer-action__icon--accept';
      break;
    case 'reject':
      iconClass = 'item-footer-action__icon--reject';
      break;
    default:
      iconClass = null;
  }

  switch (icon) {
    case 'reply':
      iconEl = (
        <span className={`item-footer-action__icon ${iconClass}`}>
          <FontAwesomeIcon icon={faReply} color="inherit" size="1x" />
        </span>
      );
      break;
    case 'forward':
      iconEl = (
        <span className={`item-footer-action__icon ${iconClass}`}>
          <FontAwesomeIcon icon={faShare} color="inherit" size="1x" />
        </span>
      );
      break;
    case 'rate':
      iconEl = (
        <span className={`item-footer-action__icon ${iconClass}`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 55.867 55.867"
            width="14"
            height="14"
          >
            <path
              d="M55.818 21.578c-.118-.362-.431-.626-.808-.681l-18.09-2.629-8.09-16.392c-.168-.342-.516-.558-.896-.558s-.729.216-.896.558l-8.091 16.393-18.09 2.629c-.377.055-.689.318-.808.681-.117.361-.02.759.253 1.024l13.091 12.76-3.091 18.018c-.064.375.09.754.397.978.309.226.718.255 1.053.076l16.182-8.506 16.18 8.506c.146.077.307.115.466.115.207 0 .413-.064.588-.191.308-.224.462-.603.397-.978l-3.09-18.017 13.091-12.761c.272-.267.37-.664.252-1.025z"
              fill="#f40"
            />
          </svg>
        </span>
      );
      break;
    default:
      iconEl = (
        <span
          className={`item-footer-action__icon ${iconClass}`}
          aria-label={caption}
          role="img"
        />
      );
  }

  const btnCls =
    'item-footer-action__action' +
    (disabled ? ' item-footer-action__action--disabled' : '');

  const onClick = () => {
    handler(item);
  };

  const className = `item-footer-action${cls ? ` ${cls}` : ''}`

  return (
    <div className={className}>
      <div className="item-footer-action__content">
        <button disabled={disabled} className={btnCls} onClick={onClick}>
          {iconEl}
          <span className="item-footer-action__caption">{caption}</span>
        </button>
      </div>
    </div>
  );
};

export default ItemFooterAction;
